import styled from 'styled-components';

export const BulletPointContainer = styled.div`
  display: flex;
  align-items: center;
  gap: var(--sizing-sm);
`;
